'use client'
import * as React from 'react'
import { BlogPlainHeroProps } from './types'

const BlogPlainHero = ({ content }: BlogPlainHeroProps) => {
    return (
        <div className="max-w-[100vw] relative after:top-[-166px] after:pointer-events-none after:z-5 after:content-[''] after:block after:absolute after:inset-0 after:bg-green-light">
            <div className="flex-col lg:flex-row flex gap-10 z-10 container">
                <div className="mt-[10%] flex-shrink-0 w-full z-10">
                    <div className="mb-[100px] lg:mb-[66px] mt-[50px] lg:mt-[60px]">{content}</div>
                </div>
                <div className="hidden lg:block [&>img]:h-full [&>img]:w-full h-[360px] lg:h-[700px] flex-shrink-0 after:rotate-[4deg] after:z-[-1] after:block after:w-[300vw] after:h-[200px] after:bottom-[50px] after:-right-[100vw] relative after:absolute after:content-[''] after:bg-white origin-top-right  right-[-16px] rotate-[-3deg] lg:rotate-[-6deg] w-full lg:w-[60%] z-10" />
            </div>
        </div>
    )
}

export default BlogPlainHero
